module.exports = __webpack_public_path__ + "static/avatar-d15b22609eca9d00ab036130d2470ce4.png";